// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"420":"74c79b62","542":"178d3adb","619":"08d450de","794":"b3033417"}[chunkId] + ".chunk.js";
};